import { 
    TOGGLE_SIDE_NAV
} from './types';

// Toggle Main Side Nav
export const toggleSideNav = () => dispatch => {
    dispatch({
        type: TOGGLE_SIDE_NAV,
    });
}